import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import it from "./it/translation.json";
import en from "./en/translation.json";
import de from "./de/translation.json";
import ro from "./ro/translation.json";
import es from "./es/translation.json";
import fr from "./fr/translation.json";
import util from "../utils/util";

export const defaultNS = "translation";

i18next
  //.use(Backend) // A plugin to load resources (translation files) from a back-end server
  .use(initReactI18next) // Enables the hook initialization module
  .init({
    lng: util.interfaceLanguage,
    debug: true,
    fallbackLng: "en",
    defaultNS,
    resources: {
      en: {
        translation: en,
      },
      it: {
        translation: it,
      },
      de: {
        translation: de,
      },
      es: {
        translation: es,
      },
      fr: {
        translation: fr,
      },
      ro: {
        translation: ro,
      },
    },
    //defaultNS,
    // if you see an error like: "Argument of type 'DefaultTFuncReturn' is not assignable to parameter of type xyz"
    // set returnNull to false (and also in the i18next.d.ts options)
    // returnNull: false,
  });
(window as any).i18next = i18next;

export default i18next;
